import { Component } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { RestEndpoint } from '../../models/rest-endpoint.model';
import { BackendResponse } from '../../shared/backend-response.model';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';

@Component({
    selector: 'app-activate-user',
    templateUrl: './activate-user.component.html',
    styleUrls: ['./activate-user.component.scss']
})
export class ActivateUserComponent extends ComponentView {

    neededParams: ObjectOfSimpleDataTypes = { key: "string" };
    key = "";

    running = true;
    resultType: 'success' | 'secondary' | 'info' | 'warning' | 'danger' | 'contrast' | undefined = null;
    resultMessage = "";

    async initParams(): Promise<boolean> {
        try {
            await RestEndpoint.main().query({key: this.key}).post().run("api/app/auth/activate").get(BackendResponse);
            this.resultType = "success";
            this.resultMessage = "Die Aktivierung war erfolgreich";
            this.running = false;
        }
        catch (ex) {
            this.resultType = "danger";
            this.resultMessage = "Die Aktivierung war nicht erfolgreich. " + BackendResponse.getFromException(ex).items[0].message;
            this.running = false;
        }
        return true;
    }

}
